import { STATIC_STRINGS } from "@asez/shared";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "store";
import { updateScheduleSetting } from "../../../../../store/steps/stepFourSlice";
import TimePeriod from "./TimePeriod";
import Duration from "./Duration";

const ScheduleOptions = () => {
  const dispatch = useDispatch();
  const { timing, scheduleSetting } = useSelector(
    (state: RootState) => state.stepFour
  );

  const handleOptionClick = (
    option: typeof STATIC_STRINGS.TIME_PERIOD | typeof STATIC_STRINGS.DURATION
  ) => {
    dispatch(updateScheduleSetting(option));
  };

  return (
    <div className="flex items-center my-2">
      <TimePeriod
        timing={timing}
        scheduleSetting={scheduleSetting}
        handleOptionClick={handleOptionClick}
      />
      <Duration
        timing={timing}
        scheduleSetting={scheduleSetting}
        handleOptionClick={handleOptionClick}
      />
    </div>
  );
};

export default ScheduleOptions;
